import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import "./Login.css";
import { useState, useEffect } from "react";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  LOGIN_START,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  FINANCIAL_YEARS,
  DEPARTMENT_INFO
} from "../../../RTK/Slices/AuthSlice";
import {
  login_user_via_send_otp,
  login_user_via_verify_otp,
  setAuthToken,
  login_user_v2,
  get_financial_year,
  portalInfo,
  fetchDefaultUser,
} from "../../../helper/Api";
import { toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";
import DepartmentOtp from "./DepartmentOtp";
import ForgetPassword from "./../ForgetPassword/Forget";
import moment from "moment";
import Spinner from "../../../components/Tools/spinner";
import ConsentModal from "./ConsentModel";
export default function Login() {
  const mainHeading = "SNA - Financial Management System";
  const [formData, setformData] = useState({
    email: null,
    password: null,
    user_type: null,
    mobile: null,
    otp: null,
  });
  const [locationStatus, setLocationStatus] = useState("idle");
  const [locationReason, setLocationReason] = useState(null);
  const [locationPayload, setLocationPayload] = useState(null);
  const [show_password, setShow_password] = useState(false);
  const [isDisabled, setDisabled] = useState(false);
  const [send_otp, setSend_otp] = useState(false);
  const [captchaValue, setCaptchaValue] = useState("");
  const recaptchaRef = React.createRef();
  const [passwordError, setPasswordError] = useState("");
  const [seconds, setSeconds] = useState(0);
  const [nextStep, setNextStop] = useState(1);
  const loginFormRef = React.useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const domainName = window.location.hostname;
  const [departmentInfo, setDepartmentInfo] = useState({
    portal_logo: null,
    portal_title: null,
  });
  const LS_CONSENT_KEY = "app_location_consent"; // "granted" | "denied" | null
  const LS_DEVICE_ID = "app_device_id";
  const [consentState, setConsentState] = useState(() => {
    try {
      return localStorage.getItem(LS_CONSENT_KEY);
    } catch (e) {
      return null;
    }
  });
  const [showModal, setShowModal] = useState(false);

  // useEffect(() => {
  //   if (consentState === null) {
  //     setTimeout(() => setShowModal(true), 200);
  //   }
  //   if (consentState === "granted") {
  //     handleLocationFinder();
  //   }
  // }, [consentState]);

  // helpers/geo.js
  // async function getLocationWithChecks(opts = {}) {
  //   // opts: { timeoutMs = 15000, highAccuracy = true }
  //   const { timeoutMs = 15000, highAccuracy = true } = opts;

  //   if (typeof navigator === "undefined" || !("geolocation" in navigator)) {
  //     throw {
  //       reason: "unsupported",
  //       message: "Geolocation API not available in this context.",
  //     };
  //   }

  //   // Try Permission API (may not exist on all browsers)
  //   try {
  //     if (navigator.permissions && navigator.permissions.query) {
  //       const p = await navigator.permissions.query({ name: "geolocation" });
  //       // p.state = 'granted' | 'prompt' | 'denied'
  //       if (p.state === "denied") {
  //         throw {
  //           reason: "permission_denied_previously",
  //           message: "User has blocked location in browser settings.",
  //         };
  //       }
  //       // If prompt or granted, proceed to request
  //     }
  //   } catch (err) {
  //     // ignore permission API failures; proceed to actual geolocation call
  //     console.warn("Permissions API check failed:", err);
  //     toast.error(err.message, {
  //       position: toast.POSITION.TOP_CENTER,
  //     });
  //   }

  //   // Wrap getCurrentPosition into promise
  //   const getPos = () =>
  //     new Promise((resolve, reject) => {
  //       navigator.geolocation.getCurrentPosition(
  //         (pos) => resolve(pos),
  //         (err) => reject(err),
  //         {
  //           enableHighAccuracy: highAccuracy,
  //           timeout: timeoutMs,
  //           maximumAge: 0,
  //         }
  //       );
  //     });

  //   try {
  //     const pos = await getPos();
  //     // Compose normalized payload
  //     const payload = {
  //       latitude: pos.coords.latitude,
  //       longitude: pos.coords.longitude,
  //       accuracy: pos.coords.accuracy ?? null,
  //       altitude: pos.coords.altitude ?? null,
  //       heading: pos.coords.heading ?? null,
  //       speed: pos.coords.speed ?? null,
  //       timestamp: new Date(pos.timestamp).toISOString(),
  //     };

  //     // Heuristic: extremely poor accuracy => consider as unreliable
  //     if (payload.accuracy == null || payload.accuracy > 1000) {
  //       // still return, but mark as low_accuracy so caller can act
  //       return { status: "low_accuracy", payload };
  //     }

  //     return { status: "success", payload };
  //   } catch (err) {
  //     // err.code: 1=PERMISSION_DENIED,2=POSITION_UNAVAILABLE,3=TIMEOUT
  //     if (err && err.code === 1)
  //       throw { reason: "permission_denied", error: err };
  //     if (err && err.code === 2)
  //       throw { reason: "position_unavailable", error: err };
  //     if (err && err.code === 3) throw { reason: "timeout", error: err };
  //     throw { reason: "unknown_error", error: err };
  //   }
  // }

  const getFinancialYear = async () => {
    try {
      const fy = await get_financial_year();
      if (fy.data.status) {
        let domainInfo;
        const res = await portalInfo({ domain: domainName });
        if (res.data.status) {
          domainInfo = res.data.result;
          dispatch(DEPARTMENT_INFO(res.data.result));
          if (res.data.result.portal_logo) {
            setDepartmentInfo({
              portal_logo: res.data.result.portal_logo,
              portal_title: res.data.result.portal_title,
            });
          } else {
            setDepartmentInfo({
              portal_logo: res.data.result.portal_logo_spare,
              portal_title: res.data.result.portal_title,
            });
          }
        }
        // fetch default user to redirect on first user page
        // const defaultUser = await fetchDefaultUser();
        // if (defaultUser.data.status) {
        //   const du = defaultUser.data.result;
        //   if(!du) {
        //     navigate("/firstuser");
        //   }
        // }

        const monthName = moment().format("MMM");
        let fy_id;
        if (monthName == "Jan" || monthName == "Feb" || monthName == "Mar") {
          fy_id = fy.data.list.find(
            (e) => e.end_year === moment().format("YYYY")
          );
        } else {
          fy_id = fy.data.list.find(
            (e) => e.start_year === moment().format("YYYY")
          );
        }
        let obj = {
          payload: {
            fy_list: fy.data.list,
            fy_id: fy_id.id,
            domainInfo,
          },
        };
        dispatch(FINANCIAL_YEARS(obj));
        localStorage.setItem("globalDateId", fy_id.id);
        setLoading(false);
      }
    } catch (error) {
      toast.error("Error fetching financial year", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const startTimer = () => {
    setSeconds(60); // Reset timer to 60 seconds
  };
  useEffect(() => {
    if (seconds > 0) {
      const timer = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [seconds]);

  useEffect(() => {
    getFinancialYear();
  }, []);

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setformData({ ...formData, [name]: value });
  };


  const validateForm = () => {
    // Validate password format
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!passwordRegex.test(formData.password)) {
      setPasswordError(
        "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one digit, and one special character."
      );
      return false;
    }
    // Add more validation logic as needed
    return true; // All fields are valid
  };

  const handleSubmit = async (e) => {
    setDisabled(true);
    e.preventDefault();
    if (send_otp) {
      await verify_otp_for_login();
    } else {
      if (!validateForm()) {
        toast.error("Invalid email or password", {
          position: toast.POSITION.TOP_CENTER,
        });
        setDisabled(false);
        return;
      }
      if (formData.email && formData.password) {
        dispatch(LOGIN_START);
        setDisabled(true);
        const loginResponse = await login_user_v2(formData);
        if (loginResponse.data.status) {
          setNextStop(2);
          sessionStorage.setItem(
            "departments",
            JSON.stringify(loginResponse.data.departments)
          );
          sessionStorage.setItem("email", formData.email);
          setDisabled(false);
        } else {
            setDisabled(false);
            toast.error(loginResponse.data.message, {
              position: toast.POSITION.TOP_CENTER,
            });
            if(loginResponse.data.user) { 
              navigate(`/firstuser/${loginResponse.data.user.id}`);
            }
          dispatch(LOGIN_FAIL("Invalid username and password"));
        }
      } else {
        toast.error("All fields Required.!", {
          position: toast.POSITION.TOP_CENTER,
        });
        setDisabled(false);
      }
    }
  };

  const handleLoginFormKeyDown = (e) => {
    if (e.key !== "Enter") {
      return;
    }

    const tagName = e.target?.tagName?.toLowerCase();
    if (tagName === "textarea") {
      return;
    }

    e.preventDefault();
    loginFormRef.current?.requestSubmit();
  };

  const verify_otp_for_login = async () => {
    if (formData.mobile && formData.otp) {
      if (!captchaValue) {
        alert("Please complete the CAPTCHA");
        setDisabled(false);
        return;
      }
      setDisabled(true);
      const loginResponse = await login_user_via_verify_otp(formData);
      if (loginResponse.data.status) {
        dispatch(LOGIN_SUCCESS(loginResponse.data));
        sessionStorage.setItem("is_loggedIn", true);
        sessionStorage.setItem(
          "userDetails",
          JSON.stringify(loginResponse.data)
        );
        sessionStorage.setItem(
          "token",
          JSON.stringify(loginResponse?.data?.token)
        );
        const { token } = loginResponse?.data;
        setAuthToken(token);
        navigate("/");
        setDisabled(false);
      } else {
        toast.error(loginResponse.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        setDisabled(false);
      }
    } else {
      toast.error("All the field required", {
        position: toast.POSITION.TOP_CENTER,
      });
      setDisabled(false);
    }
  };

  const send_otp_for_login = async (mobile) => {
    if (!mobile && formData?.mobile) {
      mobile = formData.mobile;
    }
    if (mobile && formData.user_type) {
      let post_data = {
        mobile: mobile,
        user_type: formData.user_type,
      };
      setDisabled(true);
      const loginResponse = await login_user_via_send_otp(post_data);
      if (loginResponse.data.status) {
        setSend_otp(true);
        setDisabled(false);
        setTimeout(startTimer, 500);
      } else {
        setDisabled(false);
        toast.error(loginResponse.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } else {
      toast.error("All the field required", {
        position: toast.POSITION.TOP_CENTER,
      });
      setDisabled(false);
    }
  };

  const handleSendOTP = async () => {
    const mobile = formData?.mobile;
    await send_otp_for_login(mobile);
  };

  // const handleLocationFinder = async () => {
  //   try {
  //     setLocationStatus("checking");
  //     setLocationReason(null);
  //     const result = await getLocationWithChecks({
  //       timeoutMs: 15000,
  //       highAccuracy: true,
  //     });
  //     console.log("result", result);
  //     if (result.status === "success") {
  //       setLocationStatus("ok");
  //       setLocationPayload(result.payload);
  //       return;
  //     }
  //     if (result.status === "low_accuracy") {
  //       setLocationStatus("failed");
  //       setLocationReason("low_accuracy");
  //       setLocationPayload(result.payload);
  //       return;
  //     }
  //   } catch (err) {
  //     const r =
  //       err && (err.reason || err.message)
  //         ? err.reason || err.message
  //         : "unknown_error";
  //     setLocationStatus("failed");
  //     setLocationReason(r);
  //   }
  // };

  // async function handleAccept() {
  //   localStorage.setItem(LS_CONSENT_KEY, "granted");
  //   setConsentState("granted");
  //   setShowModal(false);
  // }

  async function getPermissionState() {
    try {
      if (navigator && navigator.permissions && navigator.permissions.query) {
        const p = await navigator.permissions.query({ name: "geolocation" });
        return p.state; // 'granted' | 'prompt' | 'denied'
      }
    } catch (e) {
      // ignore
    }
    return null;
  }

  // async function handleRetry() {
  //   setLocationStatus("checking");
  //   setLocationReason(null);

  //   const ps = await getPermissionState();
  //   if (ps === "denied") {
  //     setLocationStatus("failed");
  //     setLocationReason("permission_denied");
  //     return;
  //   }

  //   // call getLocationWithChecks again — this will trigger browser popup if state is 'prompt'
  //   try {
  //     const result = await getLocationWithChecks({
  //       timeoutMs: 15000,
  //       highAccuracy: true,
  //     });
  //     if (result.status === "success") {
  //       setLocationStatus("ok");
  //       setLocationPayload(result.payload);
  //       // OPTIONAL: send to backend
  //       return;
  //     }
  //     if (result.status === "low_accuracy") {
  //       setLocationStatus("failed");
  //       setLocationReason("low_accuracy");
  //       setLocationPayload(result.payload);
  //       return;
  //     }
  //   } catch (err) {
  //     console.warn("retry failed:", err);
  //     const r =
  //       err && (err.reason || err.message)
  //         ? err.reason || err.message
  //         : "unknown_error";
  //     setLocationStatus("failed");
  //     setLocationReason(r);
  //   }
  // }

  return (
    <>
      {loading && (
        <div>
          <Spinner />
        </div>
      )}
      {/* <ConsentModal open={showModal} onAccept={handleAccept} /> */}
      {/* Show location guidance when consent granted but capture failed */}
      {/* {consentState === "granted" && locationStatus === "failed" && (
        <div
          style={{
            position: "fixed",
            left: 16,
            right: 16,
            bottom: 20,
            background: "#fff",
            border: "1px solid #eee",
            padding: 12,
            borderRadius: 8,
            boxShadow: "0 4px 18px rgba(0,0,0,0.08)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
          }}
        >
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 600, marginBottom: 6 }}>
              Location needed to continue
            </div>
            <div style={{ fontSize: 13, color: "#444" }}>
              {locationReason === "permission_denied" ||
              locationReason === "permission_denied_previously" ||
              locationReason === "permission_denied_previously"
                ? "You blocked site location. Click the lock icon in address bar → Site settings → Location → Allow, then click Retry."
                : locationReason === "position_unavailable"
                ? "Device location appears to be off. Please enable device GPS/Location and click Retry."
                : locationReason === "timeout"
                ? "Location request timed out. Move to open area and click Retry."
                : locationReason === "low_accuracy"
                ? "Location found but accuracy is poor. Enable high accuracy (GPS) and click Retry."
                : "Unable to get location. Click Retry to try again or enter pincode as fallback."}
            </div>
          </div>

          <div style={{ display: "flex", gap: 8 }}>
            <button
              style={{ padding: "8px 12px" }}
              onClick={() => {
                // manual fallback: show a simple prompt to enter pincode (you can replace with your UI)
                const pin = prompt("Enter pincode (fallback):");
                if (pin) {
                  // send manual fallback to backend if needed
                  // axios.post(`${apiUrl}/manual-location`, { userId, pincode: pin, deviceId: localStorage.getItem(LS_DEVICE_ID) || null }).catch(()=>{});
                  alert("Pincode saved");
                }
              }}
            >
              Enter pincode
            </button>

            <button
              style={{
                padding: "8px 12px",
                background: "#2490EA",
                color: "#fff",
                border: "none",
                borderRadius: 4,
              }}
              onClick={handleRetry}
            >
              Retry
            </button>
          </div>
        </div>
      )} */}

      <Grid
        container
        component="div"
        className="position-relative overflow-x-hidden"
        sx={{ height: "100vh" }}
      >
        <div
          className=" position-relative w-100 mobile-hide"
          style={{ height: "20%" }}
        >
          <div
            className="position-absolute d-flex justify-content-center align-items-center"
            style={{
              width: "160px",
              height: "160px",
              zIndex: "3",
              left: "6%",
              borderRadius: "0 0 80px 80px",
              backgroundColor: "#ffffff",
            }}
          >
            <div
              className="p-3 rounded-circle overflow-hidden"
              style={{ objectFit: "cover", objectPosition: "center" }}
            >
              <img
                src={departmentInfo.portal_logo}
                alt="logo"
                className="cursor-pointer"
                width="100%"
                onClick={() => setNextStop(1)}
              />
            </div>
          </div>

          <div
            className="position-absolute w-100"
            style={{ top: "-8%", zIndex: "2" }}
          >
            <div className="position-relative">
              <img
                src="/loginpage/darkBlueBg.svg"
                alt="svg"
                className="h-100 cursor-pointer"
              />

              <h2
                className="position-absolute text-white end-0 w-75 fw-600 text-end"
                style={{
                  top: "12%",
                  fontSize: "34px",
                  textWrap: "nowrap",
                  paddingRight: "7.2rem",
                }}
              >
                {mainHeading}
              </h2>
              <div
                className="bg-secondary-100 position-absolute end-0 w-100 top-0"
                style={{ height: "40.7%", zIndex: "-1" }}
              ></div>
            </div>
          </div>

          <div
            className="position-absolute w-100"
            style={{ top: "48%", zIndex: "1" }}
          >
            <div className="position-relative">
              <img src="/loginpage/skyBlueBg.svg" alt="svg" className="h-100" />
              <p
                className="position-absolute text-white end-0 text-end w-75"
                style={{ top: "6%", fontSize: "18px", paddingRight: "7.2rem" }}
              >
                {departmentInfo.portal_title}
              </p>
              <div
                className="bg-prime-100 position-absolute end-0 w-100"
                style={{ height: "82%", zIndex: "-1", top: "-50%" }}
              ></div>
            </div>
          </div>
        </div>

        <div className="d-lg-none w-100 mb-4 ">
          <div className="bg-secondary-100 text-white pb-3 d-flex align-items-center flex-column ">
            <div
              className="d-flex justify-content-center align-items-center bg-white p-3 rounded-circle overflow-hidden "
              style={{
                width: "160px",
                height: "160px",
                zIndex: "3",
                left: "6%",
                borderRadius: "0 0 80px 80px",
                objectFit: "cover",
                objectPosition: "center",
              }}
            >
              <img
                src={departmentInfo.portal_logo}
                alt="logo"
                width="100%"
                style={{ scale: "1.2" }}
                className="cursor-pointer"
                onClick={() => setNextStop(1)}
              />
            </div>
            <span className="d-inline-block fs-24px text-center mt-1 w-100 px-3">
              {mainHeading}
            </span>
          </div>
          <div className="bg-prime-100 py-3">
            <span className="d-inline-block fs-18px text-white text-center w-100 px-3">
              {departmentInfo.portal_title}
            </span>
          </div>
        </div>

        <Grid item xs={12} sm={12} md={12} component="div" className="d-flex">
          {/* =====================images====================== */}
          <div
            component="main"
            className="w-100 mt-lg-4"
            style={{ zIndex: "4" }}
          >
            {/* ============================form================================= */}
            <div className="container">
              <div
                className="row justify-content-between align-items-center"
                style={{ scale: "0.9" }}
              >
                <div className="h-100 col-md-12 col-lg-6 d-flex justify-content-center justify-content-lg-end">
                  {/* ============================login form=================================== */}

                  {nextStep == 1 && (
                    <Box
                      component="form"
                      ref={loginFormRef}
                      noValidate
                      sx={{ mt: 1, scale: "1" }}
                      onSubmit={handleSubmit}
                      onKeyDown={handleLoginFormKeyDown}
                      className="form_box p-4"
                    >
                      {send_otp ? (
                        <Typography
                          component="p"
                          variant="p"
                          sx={{
                            color: "blue",
                            fontWeight: "bold",
                            paddingLeft: "10px",
                            paddingTop: "10px",
                            cursor: "pointer",
                          }}
                          onClick={() => setSend_otp(false)}
                        >
                          Edit Email ?
                        </Typography>
                      ) : (
                        ""
                      )}
                      {send_otp ? (
                        <div>
                          <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="otp"
                            label="OTP"
                            type="number"
                            name="otp"
                            autoComplete="otp"
                            autoFocus
                            onChange={handleChange}
                            value={formData.otp || ""}
                          />
                          <ReCAPTCHA
                            sitekey="6Lei810pAAAAAL-HaSHvdad5f5VBl-aiil_YTJUS"
                            ref={recaptchaRef}
                            onChange={(value) => setCaptchaValue(value)}
                          />

                          <Grid item xs>
                            {seconds > 0 ? (
                              <div>
                                <p>Resend OTP after {seconds}s</p>
                              </div>
                            ) : (
                              <Link variant="body2">
                                <div>
                                  <p onClick={handleSendOTP}>Resend OTP</p>
                                </div>
                              </Link>
                            )}
                          </Grid>
                        </div>
                      ) : (
                        <div>
                          <div>
                            <h2 className="fs-24px fw-500 text-center my-3">
                              Login Into Your Account
                            </h2>
                          </div>

                          <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email"
                            name="email"
                            autoComplete="email"
                            autoFocus
                            onChange={handleChange}
                            value={formData.email || ""}
                            InputLabelProps={{ shrink: true }}
                          />
                          <span className="password_wrapper">
                            <TextField
                              onChange={handleChange}
                              margin="normal"
                              required
                              fullWidth
                              name="password"
                              label="Password"
                              type={show_password ? "text" : "password"}
                              id="password"
                              autoComplete="current-password"
                              value={formData.password || ""}
                              InputLabelProps={{ shrink: true }}
                            />

                            <span
                              className="view_password"
                              onClick={() => setShow_password(!show_password)}
                            >
                              {show_password ? (
                                <AiFillEye />
                              ) : (
                                <AiFillEyeInvisible />
                              )}
                            </span>
                          </span>
                          <ReCAPTCHA
                            sitekey="6Lei810pAAAAAL-HaSHvdad5f5VBl-aiil_YTJUS"
                            ref={recaptchaRef}
                            onChange={(value) => setCaptchaValue(value)}
                          />
                        </div>
                      )}

                      <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        disabled={isDisabled}
                        sx={{
                          mt: 3,
                          mb: 2,
                          background: "#2490EA",
                          padding: " 0.7rem 0.3rem",
                        }}
                      >
                        {send_otp ? "VERIFY OTP" : "Go Next"}
                      </Button>
                      {!send_otp ? (
                        <>
                          <Grid container>
                            <Grid item xs>
                              <Link
                                // to="/forgetPassword"
                                variant="body2"
                                className="fs-12px text-decoration-none text-black-50"
                              >
                                Forgot your password ? &nbsp;
                                <span
                                  className="text-link"
                                  onClick={() => setNextStop(3)}
                                >
                                  change now!
                                </span>
                              </Link>
                            </Grid>
                          </Grid>
                        </>
                      ) : (
                        ""
                      )}
                    </Box>
                  )}

                  {nextStep == 2 && (
                    <div style={{ scale: "0.9" }} className="mt-2">
                      {/* ======================================choose department ======================== */}
                      <DepartmentOtp locationPayload={locationPayload} />
                    </div>
                  )}

                  {nextStep == 3 && (
                    <div className="d-flex justify-content-center">
                      {/* ======================================choose department ======================== */}

                      <ForgetPassword />
                    </div>
                  )}
                </div>

                <div
                  className="col-md-12 col-lg-6 h-100 position-relative"
                  style={{ scale: "0.8" }}
                >
                  <img src="/loginpage/mandir.svg" alt="" className="w-100" />
                  <img
                    src="/loginpage/family.svg"
                    alt="vector"
                    className="position-absolute w-100"
                    style={{
                      top: "50%",
                      left: "45%",
                      translate: "-40% -45%",
                      scale: "0.6",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Grid>
        <div className="w-100">
          <div className="d-flex justify-content-between align-items-center ps-5 pe-5 pb-2">
            <p
              className="m-0"
              style={{ cursor: "pointer" }}
              onClick={() =>
                window.open("http://helpdesk.tangymedia.in", "_blank")
              }
            >
              Need Help? Contact Support
            </p>
            <p className="m-0">Powered by Tangy Media | India</p>
          </div>

          <div className="bg-prime-100 w-100" style={{ height: "5px" }}></div>
          <div
            className="bg-secondary-100 w-100"
            style={{ height: "5px" }}
          ></div>
        </div>
      </Grid>
    </>
  );
}
